import getOwnPath from '../utils/getOwnPath';

import {
  CONFIG_SUCCESS,
  INVITE_MODAL_SHOW,
  INVITE_MODAL_CLOSE,
  USER_REGISTRATION_REQUEST,
  USER_REGISTRATION_SUCCESS,
  USER_REGISTRATION_FAILURE,
} from '../actions/types';

const initialState = {
  loading: false,
  error: undefined,
  registrationErrors: undefined,
  isLoggedIn: false,
  roovite: {
    showModal: false,
  },
};

export default function userReducer(state = initialState, action = {}) {
  switch (action.type) {
    // Config is used
    case CONFIG_SUCCESS: {
      // An empty object is returned for logged out users, check a known key
      if (!action.payload.user.id) {
        return state;
      }

      const {
        full_name: fullName,
        first_name: firstName,
        last_name: lastName,
        preferred_name: preferredName,
        id,
        email,
        phone,
      } = action.payload.user;

      return {
        ...state,
        roovite: {
          ...state.roovite,
          link: action.payload.user.roovite_link,
        },
        fullName,
        firstName,
        lastName,
        preferredName,
        id,
        email,
        phone,
        isLoggedIn: true,
        isSubscriber: getOwnPath(action.payload.user, ['subscription', 'active'], false),
        loading: false,
      };
    }
    case INVITE_MODAL_SHOW:
      return {
        ...state,
        roovite: {
          ...state.roovite,
          showModal: true,
        },
      };
    case INVITE_MODAL_CLOSE:
      return {
        ...state,
        roovite: {
          ...state.roovite,
          showModal: false,
        },
      };
    case USER_REGISTRATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_REGISTRATION_SUCCESS: {
      const {
        full_name: fullName,
        first_name: firstName,
        last_name: lastName,
        preferred_name: preferredName,
        id,
        email,
        phone,
      } = action.payload.user;

      return {
        ...state,
        fullName,
        firstName,
        lastName,
        preferredName,
        id,
        email,
        phone,
        isLoggedIn: true,
        isSubscriber: getOwnPath(action.payload.user, ['subscription', 'active'], false),
        loading: false,
        registrationErrors: undefined,
      };
    }
    case USER_REGISTRATION_FAILURE: {
      const { developer_message: developerMessage, title, message, errors } = action.payload;
      let fields = {};

      if (errors) {
        Object.keys(errors).forEach((fieldName) => {
          if (errors[fieldName] && errors[fieldName].length) {
            fields = {
              ...fields,
              [fieldName]: {
                errors: errors[fieldName],
              },
            };
          }
        });
      }

      return {
        ...state,
        loading: false,
        registrationErrors: {
          developerMessage,
          title,
          message,
          fields,
        },
      };
    }
    default:
      return state;
  }
}
